// ** Third Party Imports
import styled, { keyframes } from 'styled-components'
import { ActionButton } from '@/shared/ui'


const slideInFromRight = keyframes`
	from {
		transform: translateX(100%);
		opacity: 0;
	}
	to {
		transform: translateX(0);
		opacity: 1;
	}
`

export const Separator = styled.div<{ $color?: string }>`
	height: 1px;
	background: ${({ $color, theme }) => $color ?? theme.pallette.gray.default};
	margin: 1rem -1.8rem 0 -1.8rem;
`

export const SideBarContainer = styled.div<{ $open: boolean }>`
	max-width: 260px;
	height: 100vh;
	padding: 1rem;
	background-color: ${({ theme }) => theme.pallette.geniiBlack};
	animation: ${slideInFromRight} 320ms cubic-bezier(0.22, 0.61, 0.36, 1);
	pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
	overflow: hidden;
	box-shadow: -4px 0px 12px 0px rgba(9, 18, 49, 0.25), -4px 0px 7px 0px rgba(9, 18, 49, 0.15);

	@media (max-width: 900px) {
		position: absolute;
		right: 0;
	}
`

export const SideBarHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`

export const SideBarTitle = styled.h1`
	margin: 0;
	font-size: 18px;
	font-weight: 700;
	color: ${({ theme }) => theme.pallette.geniiWhite};
`

export const SideBarSubtitle = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.pallette.text.black50};
	font-size: 14px;
`

export const ChatHistoryList = styled.div`
	padding: 0.5rem 0;
	overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: ${({ theme }) => theme.pallette.gray.default} transparent;
	scrollbar-gutter: stable;
	max-height: calc(100vh - 150px);
	margin: 0 -10px 0 0
`

export const ChatHistoryItem = styled.div`
	display: flex;
	gap: 0.5rem;
	padding: 0.5rem;
	border-radius: 8px;
	margin-bottom: 0.25rem;

	justify-content: space-between;
	align-items: center;

	/* Hide trash icon by default */
	& > svg {
		opacity: 0;
		transition: opacity 0.2s ease-in-out;		
		path {
			stroke: ${({ theme }) => theme.pallette.geniiWhite};
		}
	}

	&:hover {
		background-color: ${({ theme }) => theme.pallette.primary.greenBackground20};
		cursor: pointer;

		/* Show trash icon on hover */
		& > svg {
			opacity: 1;
		}
	}

	/* Selected chat history item */
	&.selected {
		background-color: ${({ theme }) => theme.pallette.primary.greenBackground20};
	}
`

export const ChatHistoryTitle = styled.h3`
	margin: 0;
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.pallette.geniiWhite};
`

export const ChatHistoryItemTitle = styled.h3`
	flex: 1;
	margin: 0;
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.pallette.geniiWhite};
	white-space: nowrap;
  	overflow: hidden;
  	text-overflow: ellipsis;
`

export const TransparentButton = styled(ActionButton)`
	border: none;
	box-shadow: none;

	&:hover {
		border: none;
		background: transparent;
		box-shadow: none;
		color: ${({ theme }) => theme.pallette.primary.main};
		& svg {
			path {
				stroke: ${({ theme }) => theme.pallette.primary.main};
			}
		}
		&:disabled {
			background: transparent;
		}
	}
`